import dayjs from '@/services/date'
import { ModelApiService } from './BaseApiService'

export default class ClientApiService extends ModelApiService {
  constructor() {
    super('clients')
  }

  async getBookingsByYear(clientId, timeZone, year) {
    const newDate = new Date(year, 1, 1)

    const dateFromString = dayjs(newDate).startOf('year').format('YYYY-MM-DD')
    const dateUntilString = dayjs(newDate).endOf('year').format('YYYY-MM-DD')

    return this.getBookingsByDateRange(
      clientId,
      timeZone,
      dateFromString,
      dateUntilString
    )
  }

  async getBookingsByDateRange(
    clientId,
    timeZone,
    dateFromStringLocal,
    dateUntilStringLocal
  ) {
    return this.get(
      `${clientId}/bookings/summary?timeZone=${timeZone}&dateFromLocal=${dateFromStringLocal}&dateToLocal=${dateUntilStringLocal}`
    )
  }

  async getBookingsByClientAndDate(clientId, dateFromStringLocal) {
    return this.get(`${clientId}/bookings?dateFromLocal=${dateFromStringLocal}`)
  }

  async getClientGrades(clientId) {
    return this.get(`${clientId}/grades`)
  }

  async getClientClassifications(clientId) {
    return this.get(`${clientId}/pay-classes`)
  }

  async getAdditionalDetails(clientId) {
    return this.get(`${clientId}/additional-details`)
  }

  async getClassifications(payload) {
    return await this.post('classifications', payload)
  }

  async getGrades(payload) {
    return await this.post('grades', payload)
  }
}
